// 订单页跳转到「申请退款」/「订单评价」页面时，用于传递订单数据。
// 使用 sessionStorage 保存，页面刷新后仍可用；读取后立即清除，避免残留脏数据。
const ORDER_KEY = 'happy_shopping_pending_order'

// 保存待处理的订单对象
export function saveOrder (order) {
  try {
    sessionStorage.setItem(ORDER_KEY, JSON.stringify(order || null))
  } catch (e) {
    // 忽略存储异常
  }
}

// 读取并清除待处理的订单对象
export function readOrder () {
  try {
    const raw = sessionStorage.getItem(ORDER_KEY)
    if (!raw) return null
    sessionStorage.removeItem(ORDER_KEY)
    return JSON.parse(raw) || null
  } catch (e) {
    return null
  }
}
